(function () {
  const JD = {
    round:   { name: "Round Brilliant", ratio: 1.00, depth: 0.615 },
    oval:    { name: "Oval", ratio: 1.45, depth: 0.620 },
    cushion: { name: "Cushion", ratio: 1.05, depth: 0.670 },
    emerald: { name: "Emerald", ratio: 1.40, depth: 0.670 },
    radiant: { name: "Radiant", ratio: 1.35, depth: 0.670 },
    pear:    { name: "Pear", ratio: 1.55, depth: 0.620 },
    marquise:{ name: "Marquise", ratio: 1.90, depth: 0.620 },
    princess:{ name: "Princess", ratio: 1.02, depth: 0.720 },
    asscher: { name: "Asscher", ratio: 1.00, depth: 0.680 },
    heart:   { name: "Heart", ratio: 1.00, depth: 0.620 }
  };

  function interpolate(points, ratio) {
    if (ratio <= points[0][0]) return points[0][1];
    if (ratio >= points[points.length - 1][0]) {
      return points[points.length - 1][1];
    }

    for (let i = 0; i < points.length - 1; i++) {
      const a = points[i];
      const b = points[i + 1];

      if (ratio >= a[0] && ratio <= b[0]) {
        const t = (ratio - a[0]) / (b[0] - a[0]);
        return a[1] + t * (b[1] - a[1]);
      }
    }

    return points[0][1];
  }

  function factor(shape, ratio) {
    if (shape === "round") return 0.0061;
    if (shape === "cushion") return 0.00815;
    if (shape === "princess") return 0.0085;
    if (shape === "asscher") return 0.0080;
    if (shape === "heart") return 0.0059;

    if (shape === "oval") {
      return interpolate([
        [1.25, 0.00625],
        [1.50, 0.00640],
        [2.00, 0.00670]
      ], ratio);
    }

    if (shape === "emerald") {
      return interpolate([
        [1.00, 0.0080],
        [1.50, 0.0092],
        [2.00, 0.0100],
        [2.50, 0.0106]
      ], ratio);
    }

    if (shape === "radiant") {
      return interpolate([
        [1.00, 0.0081],
        [1.50, 0.0084]
      ], ratio);
    }

    if (shape === "pear") {
      return interpolate([
        [1.25, 0.00615],
        [1.50, 0.00600],
        [1.66, 0.00590],
        [2.00, 0.00575]
      ], ratio);
    }

    if (shape === "marquise") {
      return interpolate([
        [1.50, 0.00565],
        [2.00, 0.00580],
        [2.50, 0.00585],
        [3.00, 0.00595]
      ], ratio);
    }

    return 0.0061;
  }

  function dimensionsFromCarat(shape, carat) {
    const s = JD[shape];
    const ratio = s.ratio;
    const f = factor(shape, ratio);

    const width = Math.pow(
      carat / (ratio * s.depth * f),
      1 / 3
    );

    return {
      length: width * ratio,
      width: width,
      depth: width * s.depth
    };
  }

  function calculateWeight() {
    const shapeEl = document.getElementById("jdShape");
    const lengthEl = document.getElementById("jdLength");
    const widthEl = document.getElementById("jdWidth");
    const depthEl = document.getElementById("jdDepth");
    const box = document.getElementById("jdWeightResult");

    if (!shapeEl || !lengthEl || !widthEl || !depthEl || !box) return;

    const shape = shapeEl.value;

    let length = parseFloat(lengthEl.value);
    let width = parseFloat(widthEl.value);
    let depth = parseFloat(depthEl.value);

    if (!length || !width || length <= 0 || width <= 0) {
      box.style.display = "block";
      box.innerHTML =
        "<strong>Please enter valid length and width measurements.</strong>";
      return;
    }

    if (width > length) {
      const temp = length;
      length = width;
      width = temp;
    }

    const ratio = length / width;
    let assumedDepth = false;

    if (!depth || depth <= 0) {
      if (shape === "round") {
        depth = ((length + width) / 2) * JD[shape].depth;
      } else {
        depth = width * JD[shape].depth;
      }

      assumedDepth = true;
    }

    let carat;

    if (shape === "round") {
      const avgDiameter = (length + width) / 2;
      carat = avgDiameter * avgDiameter * depth * 0.0061;
    } else {
      carat = length * width * depth * factor(shape, ratio);
    }

    const note = assumedDepth
      ? "Because you did not enter a depth measurement, a typical reference depth was assumed. Treat this as a rough estimate."
      : "This is a measurement-based estimate. Exact carat weight requires weighing the loose diamond.";

    box.style.display = "block";

    box.innerHTML =
      "<div>Estimated Carat Weight</div>" +
      "<div class='jd-result-number'>≈ " + carat.toFixed(2) + " ct</div>" +
      "<div><strong>Shape:</strong> " + JD[shape].name + "</div>" +
      "<div><strong>Measurements used:</strong> " +
      length.toFixed(2) + " × " +
      width.toFixed(2) + " × " +
      depth.toFixed(2) + " mm</div>" +
      "<p class='jd-small'>" + note + "</p>" +
      "<p><strong>Already own this natural diamond?</strong> Carat weight alone cannot determine value.</p>" +
      "<a class='jd-button' href='https://www.josephdiamonds.com/pages/send-photos-for-a-quote'>Send Photos for a Quote</a>";
  }

  function reverseCalculate() {
    const shapeEl = document.getElementById("jdReverseShape");
    const caratEl = document.getElementById("jdCarat");
    const box = document.getElementById("jdReverseResult");

    if (!shapeEl || !caratEl || !box) return;

    const shape = shapeEl.value;
    const carat = parseFloat(caratEl.value);

    if (!carat || carat <= 0) {
      box.style.display = "block";
      box.innerHTML =
        "<strong>Please enter a valid carat weight.</strong>";
      return;
    }

    const d = dimensionsFromCarat(shape, carat);

    box.style.display = "block";

    box.innerHTML =
      "<div>Approximate Reference Dimensions</div>" +
      "<div class='jd-result-number'>" +
      d.length.toFixed(1) + " × " +
      d.width.toFixed(1) + " mm</div>" +
      "<div><strong>" +
      carat.toFixed(2) + " ct " +
      JD[shape].name +
      "</strong></div>" +
      "<p class='jd-small'>Reference only. Individual diamonds of the same carat weight can vary significantly in dimensions. Fancy shapes in particular vary according to length-to-width ratio, depth, girdle thickness, and cutting style.</p>";
  }

  function compare() {
    const shapeAEl = document.getElementById("jdCompareShapeA");
    const shapeBEl = document.getElementById("jdCompareShapeB");
    const caratAEl = document.getElementById("jdCompareCaratA");
    const caratBEl = document.getElementById("jdCompareCaratB");
    const comparison = document.getElementById("jdComparison");

    if (
      !shapeAEl ||
      !shapeBEl ||
      !caratAEl ||
      !caratBEl ||
      !comparison
    ) {
      return;
    }

    const shapeA = shapeAEl.value;
    const shapeB = shapeBEl.value;

    const caratA = parseFloat(caratAEl.value);
    const caratB = parseFloat(caratBEl.value);

    if (
      !caratA ||
      !caratB ||
      caratA <= 0 ||
      caratB <= 0
    ) {
      return;
    }

    const a = dimensionsFromCarat(shapeA, caratA);
    const b = dimensionsFromCarat(shapeB, caratB);

    const largest = Math.max(a.length, b.length);
    const scale = 150 / largest;

    function stone(shape, carat, dims) {
      const w = Math.max(35, dims.width * scale);
      const h = Math.max(35, dims.length * scale);

      return (
        "<div class='jd-stone-wrap'>" +
          "<div class='jd-stone shape-" +
          shape +
          "' style='width:" +
          w +
          "px;height:" +
          h +
          "px;'></div>" +
          "<p><strong>" +
          carat.toFixed(2) +
          " ct " +
          JD[shape].name +
          "</strong><br>" +
          dims.length.toFixed(1) +
          " × " +
          dims.width.toFixed(1) +
          " mm</p>" +
        "</div>"
      );
    }

    comparison.innerHTML =
      stone(shapeA, caratA, a) +
      stone(shapeB, caratB, b);
  }

  function setIntent(button, type) {
    document
      .querySelectorAll("#jd-diamond-tool .jd-choice button")
      .forEach(function (b) {
        b.classList.remove("active");
      });

    button.classList.add("active");

    const box = document.getElementById("jdOwnerMessage");
    if (!box) return;

    let html = "";

    if (type === "sell") {
      html =
        "<strong>Considering selling a natural diamond?</strong><br>" +
        "Approximate size is useful, but value depends on much more than carat weight. Joseph Diamonds can review photos, grading documentation, and the complete piece before you schedule an appointment.<br><br>" +
        "<a class='jd-button' href='https://www.josephdiamonds.com/pages/send-photos-for-a-quote'>Send Photos of My Diamond</a>";
    }

    if (type === "inherit") {
      html =
        "<strong>Inherited a diamond?</strong><br>" +
        "Don't assume the center stone is the only source of value. The setting, natural accent diamonds, precious metal, designer marks, and estate characteristics may also matter.<br><br>" +
        "<a class='jd-button' href='https://www.josephdiamonds.com/pages/send-photos-for-a-quote'>Send Photos for a Professional Review</a>";
    }

    if (type === "own") {
      html =
        "<strong>Already own the diamond?</strong><br>" +
        "If it is a natural diamond, its dimensions and approximate weight are only the beginning. Learn how professional buyers evaluate the complete stone.<br><br>" +
        "<a class='jd-button' href='https://www.josephdiamonds.com/pages/why-some-diamond-rings-are-worth-thousands-more-than-others'>Learn What Determines Diamond Value</a>";
    }

    if (type === "shop") {
      html =
        "<strong>Shopping for a diamond?</strong><br>" +
        "Use the charts as size references, but remember that carat weight, physical dimensions, and diamond quality are different measurements.";
    }

    if (type === "research") {
      html =
        "<strong>Researching diamond sizes?</strong><br>" +
        "Explore the shape-specific charts below or compare two diamonds side by side.";
    }

    box.innerHTML = html;
    box.style.display = "block";
  }

  function initDiamondCalculator() {
    const tool = document.getElementById("jd-diamond-tool");

    if (!tool) return;

    const calculateButton = tool.querySelector(
      "[data-jd-action='calculate']"
    );

    const reverseButton = tool.querySelector(
      "[data-jd-action='reverse']"
    );

    const compareButton = tool.querySelector(
      "[data-jd-action='compare']"
    );

    if (calculateButton) {
      calculateButton.addEventListener(
        "click",
        calculateWeight
      );
    }

    if (reverseButton) {
      reverseButton.addEventListener(
        "click",
        reverseCalculate
      );
    }

    if (compareButton) {
      compareButton.addEventListener(
        "click",
        compare
      );
    }

    tool
      .querySelectorAll("[data-jd-intent]")
      .forEach(function (button) {
        button.addEventListener("click", function () {
          setIntent(
            button,
            button.getAttribute("data-jd-intent")
          );
        });
      });

    compare();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initDiamondCalculator
    );
  } else {
    initDiamondCalculator();
  }
})();